module.exports = __webpack_public_path__ + "img/d604582.jpg";